export class SIQTabBarTheme {
  backgroundColor = "null";
  activeTabColor = "null";
  inactiveTabColor = "null";
}
//# sourceMappingURL=SIQTabBarTheme.js.map